var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3909 8.48977C23.3909 13.1786 19.6073 16.9795 14.9398 16.9795C10.2725 16.9795 6.48877 13.1786 6.48877 8.48977C6.48877 3.80101 10.2725 0 14.9398 0C19.6073 0 23.3909 3.80101 23.3909 8.48977ZM21.8685 8.48977C21.8685 12.3339 18.7665 15.4502 14.9398 15.4502C11.1133 15.4502 8.01116 12.3339 8.01116 8.48977C8.01116 4.64562 11.1133 1.52936 14.9398 1.52936C18.7665 1.52936 21.8685 4.64562 21.8685 8.48977Z",
    fill: "#62C776"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 26.4357C0 22.2581 3.37122 18.8714 7.52983 18.8714H22.4702C26.6288 18.8714 30 22.2581 30 26.4357C30 30.6134 26.6288 34 22.4702 34H7.52983C3.37122 34 0 30.6134 0 26.4357ZM7.52983 20.4008H22.4702C25.788 20.4008 28.4776 23.1027 28.4776 26.4357C28.4776 29.7687 25.788 32.4706 22.4702 32.4706H7.52983C4.21204 32.4706 1.52239 29.7687 1.52239 26.4357C1.52239 23.1027 4.21204 20.4008 7.52983 20.4008Z",
    fill: "#62C776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuario);
export default __webpack_public_path__ + "static/media/usuario.ef5edab5b3963e3c00a6ec7fe2ca8cad.svg";
export { ForwardRef as ReactComponent };